import { getPlatformBasePath, isAviosPlatform, AVIOS_DOMAIN } from '~/utils/platform'
import { isLocal } from '~/utils/envChecks'
import { sanitizeBaseUrl } from '@reward-platform/utils'
import { HEADER_KEYS } from '@reward-platform/shared-schemas'
import { getHeaderFromRequest, NextRequestParameter } from './nextRequest'
import { RequestInvalidError } from '../errors/RequestInvalidError'

const addBasePathToUrl = (baseUrl: string) => {
  const basePath = getPlatformBasePath()
  if (basePath) {
    return baseUrl + basePath
  }

  return baseUrl
}

export const getBaseUrlFromServer = (req: NextRequestParameter, includeBasePath = true): string => {
  const host = getHeaderFromRequest(req, HEADER_KEYS.host)
  const forwardedHost = getHeaderFromRequest(req, HEADER_KEYS.forwardedHost)

  if (!host) {
    throw new RequestInvalidError('Missing host header')
  }

  if (isLocal()) {
    const localHost = sanitizeBaseUrl(host, true)
    return addBasePathToUrl(localHost)
  }

  const isValidForwardedHost = forwardedHost?.includes(AVIOS_DOMAIN)

  const envHost = isAviosPlatform() && isValidForwardedHost ? (forwardedHost as string) : host

  const baseUrlForEnv = sanitizeBaseUrl(envHost)

  return includeBasePath ? addBasePathToUrl(baseUrlForEnv) : baseUrlForEnv
}
